import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function DonateCancel() {
  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main className="pt-28 pb-16">
        <div className="max-w-[720px] mx-auto px-4 sm:px-6 lg:px-12 py-20 text-center">
          <XCircle className="w-14 h-14 text-[#4B5563] mx-auto mb-5" />
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-[#0B132B] mb-4">
            Donation cancelled.
          </h1>
          <p className="text-[#4B5563] max-w-md mx-auto mb-8">
            No payment was taken. If you'd like to give it another try, we're here whenever you're
            ready. If you meant to complete the donation, please try again.
          </p>
          <div className="flex gap-3 justify-center flex-wrap">
            <Link to="/donate" className="btc-btn-primary">Try again <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/" className="btc-btn-outline">Back to home</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
